import _assign from "object-assign";
import { createTypography } from './createTypography'; // TODO: Figure out how to deprecate the serif styles and legacy sizes.... move them to a separate file?

var _createTypography = createTypography(),
    getFace = _createTypography.getFace,
    size = _createTypography.size;

var typography = {
  _fontFaces: {
    sansSerifFontFamilyLight: getFace('light').fontFamily,
    sansSerifFontFamilyRegular: getFace('regular').fontFamily,
    sansSerifFontFamilySemiBold: getFace('semiBold').fontFamily,
    sansSerifFontFamilyBold: getFace('bold').fontFamily,
    serifFontFamilyLight: 'PlayfairDisplay-Light',
    serifFontFamilyRegular: 'PlayfairDisplay-Regular',
    serifFontFamilyBold: 'PlayfairDisplay-Bold'
  },
  sansSerifHighlight3: _assign({
    fontWeight: 'normal'
  }, getFace('bold'), {
    fontSize: "".concat(size[210], "px"),
    lineHeight: '1.14285714em',
    letterSpacing: '-1.5'
  }),
  sansSerifHighlight2: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[180], "px"),
    lineHeight: '1.25em',
    letterSpacing: '-1.5'
  }),
  sansSerifHighlight2Light: _assign({
    fontWeight: 'normal'
  }, getFace('light'), {
    fontSize: "".concat(size[180], "px"),
    lineHeight: '1.25em',
    letterSpacing: '-1.5'
  }),
  sansSerifHighlight2Bold: _assign({
    fontWeight: 'normal'
  }, getFace('bold'), {
    fontSize: "".concat(size[180], "px"),
    lineHeight: '1.25em',
    letterSpacing: '-1.5'
  }),
  sansSerifHighlight2SemiBold: _assign({
    fontWeight: 'normal'
  }, getFace('semiBold'), {
    fontSize: "".concat(size[180], "px"),
    lineHeight: '1.25em',
    letterSpacing: '-1.5'
  }),
  sansSerifHighlight1: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[130], "px"),
    lineHeight: '1.2em'
  }),
  sansSerifHighlight1Light: _assign({
    fontWeight: 'normal'
  }, getFace('light'), {
    fontSize: "".concat(size[130], "px"),
    lineHeight: '1.2em'
  }),
  sansSerifHeadline: _assign({
    fontWeight: 'normal'
  }, getFace('light'), {
    fontSize: "".concat(size[100], "px"),
    lineHeight: '1.2em'
  }),
  sansSerifSubHeading: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[70], "px"),
    lineHeight: '1.625em'
  }),
  sansSerifBody1: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[60], "px"),
    lineHeight: '1.85714286em'
  }),
  sansSerifBody2: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[50], "px"),
    lineHeight: '1.83333333em'
  }),
  sansSerifCaption: _assign({
    fontWeight: 'normal'
  }, getFace(), {
    fontSize: "".concat(size[30], "px"),
    lineHeight: '1.8em'
  }),
  serifHighlight3Large: {
    fontFamily: 'PlayfairDisplay-Bold',
    fontSize: '120px',
    lineHeight: '1.666667em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3Medium: {
    fontFamily: 'PlayfairDisplay-Bold',
    fontSize: '88px',
    lineHeight: '1.13636364em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3Small: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3SmallBold: {
    fontFamily: 'PlayfairDisplay-Bold',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3SmallLight: {
    fontFamily: 'PlayfairDisplay-regular',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight2: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight2Light: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight1: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  serifHighlight1Light: {
    fontFamily: 'PlayfairDisplay-Light',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  serifHeadline: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '22px',
    lineHeight: '1.63636364em',
    fontWeight: 'normal'
  },
  serifHeadline2: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal'
  },
  serifHeadline2Bold: {
    fontFamily: 'PlayfairDisplay-Bold',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal'
  },
  serifSubHeading: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '16px',
    lineHeight: '1.625em',
    fontWeight: 'normal'
  },
  serifSubHeading2: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '22px',
    lineHeight: '1.63636364em',
    fontWeight: 'normal'
  },
  serifBody1: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '14px',
    lineHeight: '1.85714286em',
    fontWeight: 'normal'
  },
  serifBody2: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '12px',
    lineHeight: '1.83333333em',
    fontWeight: 'normal'
  },
  serifButton: {
    fontFamily: 'PlayfairDisplay-Bold',
    fontSize: '12px',
    lineHeight: '1.83333333em',
    fontWeight: 'normal',
    letterSpacing: '1',
    textTransform: 'uppercase'
  },
  serifCaption: {
    fontFamily: 'PlayfairDisplay-Regular',
    fontSize: '10px',
    lineHeight: '1.8em',
    fontWeight: 'normal'
  },
  size10: {
    fontSize: "".concat(size[30], "px")
  },
  size12: {
    fontSize: "".concat(size[50], "px")
  },
  size14: {
    fontSize: "".concat(size[60], "px")
  },
  size15: {
    // TODO: Determine if we need to keep this
    fontSize: '15px'
  },
  size16: {
    fontSize: "".concat(size[70], "px")
  },
  size18: {
    fontSize: "".concat(size[80], "px")
  },
  size22: {
    fontSize: "".concat(size[100], "px")
  },
  size30: {
    fontSize: "".concat(size[130], "px")
  },
  size38: {
    fontSize: "".concat(size[160], "px")
  },
  size44: {
    fontSize: "".concat(size[180], "px")
  },
  size56: {
    fontSize: "".concat(size[210], "px")
  },
  size64: {
    fontSize: "".concat(size[240], "px")
  },
  size88: {
    // TODO: Determine if we need to keep this
    fontSize: '88px'
  },
  size120: {
    // TODO: Determine if we need to keep this
    fontSize: '120px'
  }
};
export default typography;